import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetOneOtherSupportingParties = createAsyncThunk(
  "GetOneOtherSupportingParties/GetOneOtherSupportingParties",
  async (otherSupportingPartiesId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/OtherSupportingParties/GetOtherSupportingPartiesById",
        {
          otherSupportingPartiesId: otherSupportingPartiesId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const DeleteOtherSupportingParties = createAsyncThunk(
  "DeleteOtherSupportingParties/DeleteOtherSupportingParties",
  async (otherSupportingPartiesId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/OtherSupportingParties/DeleteOtherSupportingParties",
        {
          otherSupportingPartiesId: otherSupportingPartiesId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const GetListOtherSupportingParties = createAsyncThunk(
  "GetListOtherSupportingParties/GetListOtherSupportingParties",
  async (applicationInformationId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/OtherSupportingParties/GetOtherSupportingPartiesListByAppGuid",
        {
          applicationInformationId: applicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const UpdateOtherSupportingParties = createAsyncThunk(
  "UpdateOtherSupportingParties/UpdateOtherSupportingParties",
  async (OtherSupportingPartiesData, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/OtherSupportingParties/UpdateOtherSupportingParties",
        {
          otherSupportingPartiesId:
            OtherSupportingPartiesData.otherSupportingPartiesId,
          supportingPartyName: OtherSupportingPartiesData.supportingPartyName,
          durationInMonths: OtherSupportingPartiesData.durationInMonths,
          supportTypeId: OtherSupportingPartiesData.supportTypeId,
          supportValue: OtherSupportingPartiesData.supportValue,
          supportCoverage: OtherSupportingPartiesData.supportCoverage,
          applicationInformationId:
            OtherSupportingPartiesData.applicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const AddOtherSupportingPartiesData = createAsyncThunk(
  "AddOtherSupportingPartiesData/AddOtherSupportingPartiesData",
  async (OtherSupportingPartiesData, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/OtherSupportingParties/AddOtherSupportingParties",
        {
          supportingPartyName: OtherSupportingPartiesData.supportingPartyName,
          durationInMonths: OtherSupportingPartiesData.durationInMonths,
          supportTypeId: OtherSupportingPartiesData.supportTypeId,
          supportValue: OtherSupportingPartiesData.supportValue,
          supportCoverage: OtherSupportingPartiesData.supportCoverage,
          applicationInformationId:
            OtherSupportingPartiesData.applicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "addJobOpportun");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const ValidateOtherSupportingParties = createAsyncThunk(
  "ValidateOtherSupportingParties/ValidateOtherSupportingParties",
  async (Validate, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/OtherSupportingParties/ValidateOtherSupportingParties",
        {
          supportingPartyName: Validate.supportingPartyName,
          durationInMonths: Validate.durationInMonths,
          supportTypeId: Validate.supportTypeId,
          supportValue: Validate.supportValue,
          supportCoverage: Validate.supportCoverage,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      if (response.data.success === true) {
        const arrayValidate = response.data.result.map((ele, ind) => {
          return ele.code;
        });
        return arrayValidate; // Return the extracted data
      }
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const OneOtherSupportingParties = createSlice({
  name: "OneOtherSupportingParties",
  initialState: {
    OneOtherSupportingParties: {},
    loadingOneOtherSupportingParties: false,
    errorOneOtherSupportingParties: null,

    AddOtherSupportingParties: {},
    loadingAddOtherSupportingParties: false,
    errorAddOtherSupportingParties: null,

    UpdateOtherSupportingParties: {},
    loadingUpdateOtherSupportingParties: false,
    errorUpdateOtherSupportingParties: null,

    DeleteOtherSupportingParties: {},
    loadingDeleteOtherSupportingParties: false,
    errorDeleteOtherSupportingParties: null,

    ListOtherSupportingParties: {},
    loadingListOtherSupportingParties: false,
    errorListOtherSupportingParties: null,

    OtherSupportingPartiesValidate: [],
    loadingOtherSupportingPartiesValidate: false,
    errorOtherSupportingPartiesValidate: null,
  },
  reducers: {
    restValidateOtherSupportingParties: (state, action) => {
      state.OtherSupportingPartiesValidate = [];
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(GetOneOtherSupportingParties.pending, (state, action) => {
        state.loadingOneOtherSupportingParties = true;
        state.OneOtherSupportingParties = action.payload;
        state.errorOneOtherSupportingParties = null;
      })
      .addCase(GetOneOtherSupportingParties.fulfilled, (state, action) => {
        state.loadingOneOtherSupportingParties = false;
        state.OneOtherSupportingParties = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetOneOtherSupportingParties.rejected, (state, action) => {
        state.loadingOneOtherSupportingParties = false;
        state.errorOneOtherSupportingParties = action.payload;
      })

      .addCase(DeleteOtherSupportingParties.pending, (state, action) => {
        state.loadingDeleteOtherSupportingParties = true;
        state.DeleteOtherSupportingParties = action.payload;
        state.errorDeleteOtherSupportingParties = null;
      })
      .addCase(DeleteOtherSupportingParties.fulfilled, (state, action) => {
        state.DeleteOtherSupportingParties = false;
        state.DeleteOtherSupportingParties = action.payload; // Assuming payload has the desired data
      })
      .addCase(DeleteOtherSupportingParties.rejected, (state, action) => {
        state.loadingDeleteOtherSupportingParties = false;
        state.errorDeleteOtherSupportingParties = action.payload;
      })
      .addCase(GetListOtherSupportingParties.pending, (state, action) => {
        state.loadingListOtherSupportingParties = true;
        state.ListOtherSupportingParties = action.payload;
        state.errorListOtherSupportingParties = null;
      })
      .addCase(
        GetListOtherSupportingParties.fulfilled,
        (state, action) => {
          state.loadingListOtherSupportingParties = false;
          state.ListOtherSupportingParties = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(GetListOtherSupportingParties.rejected, (state, action) => {
        state.loadingListOtherSupportingParties = false;
        state.errorListOtherSupportingParties = action.payload;
      })
      .addCase(UpdateOtherSupportingParties.pending, (state, action) => {
        state.loadingUpdateOtherSupportingParties = true;
        state.UpdateOtherSupportingParties = action.payload;
        state.errorUpdateOtherSupportingParties = null;
      })
      .addCase(UpdateOtherSupportingParties.fulfilled, (state, action) => {
        state.loadingUpdateOtherSupportingParties = false;
        state.UpdateOtherSupportingParties = action.payload; // Assuming payload has the desired data
      })
      .addCase(UpdateOtherSupportingParties.rejected, (state, action) => {
        state.loadingUpdateOtherSupportingParties = false;
        state.errorUpdateOtherSupportingParties = action.payload;
      })
      .addCase(ValidateOtherSupportingParties.pending, (state, action) => {
        state.loadingOtherSupportingPartiesValidate = true;
        state.OtherSupportingPartiesValidate = action.payload;
        state.errorOtherSupportingPartiesValidate = null;
      })
      .addCase(
        ValidateOtherSupportingParties.fulfilled,
        (state, action) => {
          state.loadingOtherSupportingPartiesValidate = false;
          state.OtherSupportingPartiesValidate = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        ValidateOtherSupportingParties.rejected,
        (state, action) => {
          state.loadingOtherSupportingPartiesValidate = false;
          state.errorOtherSupportingPartiesValidate = action.payload;
        }
      )
      .addCase(AddOtherSupportingPartiesData.pending, (state, action) => {
        state.loadingAddOtherSupportingParties = true;
        state.AddOtherSupportingParties = action.payload;
        state.errorAddOtherSupportingParties = null;
      })
      .addCase(
        AddOtherSupportingPartiesData.fulfilled,
        (state, action) => {
          state.loadingAddOtherSupportingParties = false;
          state.AddOtherSupportingParties = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(AddOtherSupportingPartiesData.rejected, (state, action) => {
        state.loadingAddOtherSupportingParties = false;
        state.errorAddOtherSupportingParties = action.payload;
      });
  },
});
export const { restValidateOtherSupportingParties } =
  OneOtherSupportingParties.actions;
export default OneOtherSupportingParties.reducer;
